import { path } from 'ramda'
import { useSelector, shallowEqual } from 'react-redux'

import { Settings, dataKey } from 'app/reducers/settings/dishesAsRawItems'

export { dataKey }

export const useRawItemsSettings = () => {
  const settings: Settings = useSelector(path(['settings', dataKey]), shallowEqual)!
  return settings
}
